import { Accordion, Badge, Group, Stack, Text } from '@mantine/core';

import { StepCard } from './StepCard';

import type { TestPhase, TestStep } from '@admin/hooks/request-logger/useTestGenerator';

interface PhaseAccordionItemProps {
  phase: TestPhase;
  index: number;
  onRequestClick?: (requestId: string) => void;
}

export const PhaseAccordionItem = ({ phase, index, onRequestClick }: PhaseAccordionItemProps) => {
  return (
    <Accordion.Item value={`phase-${index}`}>
      <Accordion.Control>
        <Group justify="space-between">
          <Text fw={500}>
            {phase.phase.name} ({phase.steps.length} request{phase.steps.length !== 1 ? 's' : ''})
          </Text>
          <Badge size="sm" variant="light">
            Phase {phase.phase.order}
          </Badge>
        </Group>
      </Accordion.Control>
      <Accordion.Panel>
        <Stack gap="md">
          {phase.steps.map((step: TestStep, stepIndex: number) => (
            <StepCard key={stepIndex} step={step} stepIndex={stepIndex} onRequestClick={onRequestClick} />
          ))}
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
};
